/**
 * GA4 event tracking — cienka warstwa nad gtag/dataLayer.
 *
 * Wysyłka działa nawet jeśli użytkownik nie zaakceptował zgód analytics —
 * Google Consent Mode v2 sam blokuje wysyłkę cookies/danych dopóki nie ma
 * zgody (`analytics_storage = denied`), więc po stronie aplikacji wystarczy
 * po prostu wywołać event.
 *
 * W GA4 oznacz w panelu jako "Kluczowe zdarzenia" (dawniej Konwersje):
 *  - cta_book_call
 *  - form_start
 *  - generate_lead
 */

type GA4EventName =
  | "cta_book_call"
  | "form_start"
  | "form_submit"
  | "generate_lead"
  | "newsletter_signup"
  | "lead_magnet_download";

type GA4EventParams = {
  /** Sekcja/strona, z której pochodzi akcja (hero, header, footer, sticky, faq, contact). */
  location?: string;
  /** Identyfikator formularza (contact, newsletter, lead_magnet). */
  form_id?: string;
  /** Metoda kontaktu (form, calendly, mailto, phone). */
  method?: string;
  /** Wartość konwersji w PLN — pomocna dla raportów ROI. */
  value?: number;
  currency?: string;
  [key: string]: unknown;
};

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: GA4EventName, params: GA4EventParams = {}): void {
  if (typeof window === "undefined") return;
  try {
    const payload = { ...params };
    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    }
  } catch {
    // ignore — analytics nigdy nie może wysadzić UI
  }
}
